<template>
  <div class="blog-social">
    {{ messages.share }}:
    <a v-for="({ href }, key) in shareLinks" :href="href" class="blog-social__item">
      <svg class="blog-social__icon"><use :xlink:href="`#svg-${key}`"></use></svg>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();

const shareLinks = computed(() => resultsStore.blogElement?.shareLinks);
const messages = computed(() => resultsStore?.messages?.blog);
</script>

<style lang="scss" scoped>
.blog-social {
  display: flex;
  align-items: center;
  &__item {
    display: flex;
    align-items: center;
    margin-left: 12px;
  }
  &__icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}
</style>
